export enum KeysLocalStorage {
  access_token = 'access_token',
  refresh_token = 'refresh_token',
}
